import gql from "graphql-tag";

export const POSTS_QUERY = gql`
  query ($cursor: String!, $filters: PostsFilter) {
    posts(sort: [CREATED_AT_DESC], first: 15, filters: $filters, after: $cursor) {
      edges {
        node {
          id
          link
          postContent
          createdAt
          isLiked
          postType
          createdAt
          userId
          likedUsers
          likeCounts
          brand {
            thumbnailImageUrl
            companyName
            id
            values
            vanityUrlName
          }
          media {
            id
            originalUrl
            croppedUrl
            cropParams
            productTags
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
